<template>
  <div>
    <div
      class="
        container-fluid
        d-flex
        flex-column
        align-items-center
        justify-content-center
      "
    >
      <div class="col-lg-3 mb-lg-5">
        <div class="progress-step-bar">
          <div class="step" @click="changeStep(1)">
            <div class="bullet"></div>
            <p>Step 1</p>
          </div>
          <div class="step" @click="changeStep(2)">
            <div class="bullet"></div>
            <p>Step 2</p>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <RegisterForm1 v-if="stepOne" />

        <RegisterForm2 v-if="stepTwo" />
      </div>
    </div>
  </div>
</template>

<script>
import RegisterForm1 from "./RegisterForm1";
import RegisterForm2 from "./RegisterForm2";
export default {
  components: {
    RegisterForm1,
    RegisterForm2,
  },
  data() {
    return {
      stepOne: true,
      stepTwo: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    changeStep: function (index) {
      if (index == 1) {
        this.stepOne = true;
        this.stepTwo = false;
      } else {
        this.stepOne = false;
        this.stepTwo = true;
      }
    },
  },
};
</script>
<style>
.progress-step-bar {
  display: flex;
  justify-content: space-between;
}
.progress-step-bar .step {
  text-align: center;
}
.progress-step-bar .step p {
  font-weight: 600;
}
.progress-step-bar .step .bullet {
  height: 20px;
  width: 20px;
  border: 2px solid #dedede;
  display: inline-block;
  border-radius: 50%;
  position: relative;
  transition: 0.2s;
  font-weight: 500;
  background: #dedede;
}
.progress-step-bar .step:before {
  content: "";
  width: 80%;
  height: 1px;
  background: #dedede;
  position: absolute;
  left: 8%;
  top: 9px;
  z-index: -1; /*put it behind the numbers*/
}
</style>



// WEBPACK FOOTER //
// src/components/forms/NavRegister.vue